import dereekOpperman from "./Assests/img/dereek-opperman.webp";
import ChrisTrammell from "./Assests/img/christrammel.webp";
import FranciscoRamos from "./Assests/img/franciscorameo.webp";
import JamieAtkinson from "./Assests/img/jamieatkinson.webp";
import AllisonWells from "./Assests/img/alliesenWells.webp";
import AbigailOrtega from "./Assests/img/abigialOrtiga.webp";
import malachiMott from "./Assests/img/malachimott.webp";
import henryQui from "./Assests/img/henryqui.webp";
import Summits from "./Assests/img/summits.webp";
import Facilitator from "./Assests/img/Facilitator.webp";
import Speaking from "./Assests/img/speaking.webp";
import IndividualPillars from "./Assests/img/IndividualPillars.webp";
import ChallengesImg from "./Assests/img/Challenges.webp";
import ContinuedLearning from "./Assests/img/ContinuedLearning.webp";
export const team = [
  {
    img: [dereekOpperman],
    name: "Derek Opperman",
    designation: "Corporate Wellness Coach",
    description:
      "Derek Opperman is a decorated athlete, all-natural physique competitor, and Fortune 500 speaker who never forgets he was just a middle-class kid with a big head, bad haircut, and bad skin until he discovered health is a choice to make every single day. He acknowledges and speaks to the inner nerd in all of us.Derek is based in LA, California, and is available for speaking events across the US, global and virtual summits, podcasts, and interviews.",
  },
  {
    img: [ChrisTrammell],
    name: "Chris Trammell",
    designation: "Mindset and Performance",
    description:
      "Life Work Expert, and Purpose and Performance Coach. My diverse, multi-passionate career combines nearly 2 decades of Transformational Work and Coaching, 20 years of Sports Psychology & Competition, Educational Program & Curriculum Development, and Leader- ship Training while weaving in effective communication, timeless wisdom, and inspiring human potential. I cause others to shine.",
  },
  {
    img: [FranciscoRamos],
    name: "Francisco Ramos",
    designation: "Mindfulness and Meditation",
    description:
      "Francisco Ramos is the self care specialist bringing awareness to the mind and body. With over 10 years of experience, Francisco is trained in facilitating yoga practices, meditations, sound baths, breathwork exercises, and group discussions. He works with individuals or groups, leading conversations on topics such as workplace empathy, inclusivity, and gratitude. Francisco inspires others to connect with themselves and each other.",
  },
  {
    img: [JamieAtkinson],
    name: "Jamie Atkinson",
    designation: "Yoga, Ayurveda & Sound meditation",
    description:
      "Jamie Sue is a Chopra Global certified instructor in Ayurveda: Perfect Health and Primordial Sound Meditation. She is passionate about empowering others to live life with more purpose, balance, and peace using Ayurvedic principles. These are the tools that transformed her life for the better, allowing her to heal, connect to her wholeness, and live life with deeper joy. She is grateful to share this knowledge and inspire others to create greater well being in their own lives.",
  },
  {
    img: [AllisonWells],
    name: "Allison Wells",
    designation: "Nutrition",
    description:
      "Allison is a born and raised health-conscious Californian, becoming a vegetarian at 14. Since then has spent a lifetime making plant based foods unequivocally delicious. She supplemented her love of food with science and performance, receiving multiple nutrition certifications and a degree from the University of Colorado in broadcast journalism. Today you can find her coaching and consulting with private clients, groups and companies as well as on local Los Angeles Television stations.",
  },
  {
    img: [AbigailOrtega],
    name: "Abigail Ortega",
    designation: "Stress management",
    description:
      "Abigail D. Ortega, LCSW is a Licensed Clinical Social Worker who leads a group psychotherapy practice. Before starting her private counseling practice, Abigail worked in several community, educational and medical settings. Her diverse experience included providing assessments and therapy to people and families of all ages and backgrounds. In addition to Abigail’s extensive experience working with children, teens and families, she has expertise in counseling.",
  },
  {
    img: [malachiMott],
    name: "Malachi Mott",
    designation: "Creativity and Play",
    description:
      "Malachi empowers artists to create art the world deserves. Based in L.A., Malachi is dedicated to creating artistic masterpieces as well as helping others do the same. With over 15 years as a professional musician, he is able to produce many styles of music to high levels while supporting other artists in doing the same. Upon graduating from Berklee College of Music, Malachi honed his skills in the studios at Interscope Records for 6 years. Currently, he remixes and produces music via SoundBetter.com as well as.",
  },
  {
    img: [henryQui],
    name: "Dr. Henry Qiu",
    designation: "Sleep, rest and recovery",
    description:
      "Is a doctor of sleep medicine treating insomnia & sleep apnea for children and adults in the greater Los Angeles area. Through his comprehensive education at UCLA, the International Academy of Sleep, and the American Academy of Sleep Medicine he has acquired a deep understanding of how poor sleep can be the core cause of almost all chronic illnesses. These illnesses such as depression, diabetes, strokes, heart attacks, and dementia significantly affect child development and quality of life in adults.",
  },
];
export const SummitsAndConferences = [
  {
    img: [Summits],
    name: "Summits and Conferences",
    description:
      "We're available to conduct keynote speeches, workshop pillars,health 'scavenger hunts',and friendly competition to keep events fun, effective and memorable.",
  },
  {
    img: [Facilitator],
    name: "Expert Facilitator & Consultant on Corporate Health & Wellness",
    description:
      "Let Derek support you and your teams with establishing, elevating,or redesigning your Corporate Health and Wellness programs. From forming your employee health and wellness committee, to establishing the best regimen - from your busy C-suite executives to all the team members in between,Derek is the #1 facilitator to guide your company's workplace wellbeing programs' success.",
  },
  {
    img: [Speaking],
    name: "Speaking & Keynote",
    description:
      "Have Derek come to and speak at your next Company Wellness Day or Promotional Health event.",
  },
];
export const ChallengesSection = [
  {
    img: [IndividualPillars],
    name: "Individual Pillars",
    description:
      "Each one of the aforementioned pillars can be conducted in conjunction with a company theme, for an already-set monthly topic.",
  },
  {
    img: [ChallengesImg],
    name: "Challenges",
    description:
      "30-day guided challenges can be done in conjunction with any pillar or as a standalone offering, bringing the distinction the workshops to daily life.",
  },
  {
    img: [ContinuedLearning],
    name: "Continued Learning",
    description:
      "Weekly or twice-weekly classes for compa- nies that want to offer their employees ongoing support with any of the pillar topics.",
  },
];
